import { type } from './type.js';

/**
 * @description
 * Checks if `value` is classified as a `Function` object.
 *
 * @example
 * ``` ts
 * isFunction(() => {});
 * // => true
 * isFunction(undefined);
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a function, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-function
 */
export const isFunction = (value): value is () => void => {
  return type(value) === 'function';
};
